import { cn } from "@/lib/cn";
import { Card } from "@/components/ui/Card";

type AdminMetricTone = "neutral" | "good" | "warn" | "busy";

const toneClass: Record<AdminMetricTone, string> = {
  neutral: "text-ink",
  good: "text-good-text",
  warn: "text-flag-text",
  busy: "text-accent-text",
};

export function AdminMetricTile({
  label,
  value,
  sub,
  tone = "neutral",
  testid,
}: {
  label: string;
  value: string;
  sub?: string;
  tone?: AdminMetricTone;
  testid?: string;
}) {
  return (
    <Card
      data-testid={testid}
      data-tone={tone}
      padded={false}
      className="min-w-0 px-3 py-2"
    >
      <div className="eyebrow text-[0.6rem]">{label}</div>
      <div className={cn("mt-1 truncate font-mono text-lg", toneClass[tone])}>
        {value}
      </div>
      {sub ? (
        <div className="mt-0.5 truncate text-[0.65rem] text-ink-muted">
          {sub}
        </div>
      ) : null}
    </Card>
  );
}
